import * as React from "react"
import {batch} from "@preact/signals-react";
import {ToggleButtonSeeker} from "@ui-seeker/core";

import {GROUPED_BY} from "@constants"
import {groupedBy} from "@signals";
import {isLoadingByGroupToggle} from "../@signals";


const GROUPED_TABS = [
    { value: GROUPED_BY.COUNTRY, label: 'Market' },
    { value: GROUPED_BY.RETAILER, label: 'Retailer' },
    { value: GROUPED_BY.CATEGORY, label: 'Category' },
    { value: GROUPED_BY.BRAND, label: 'Brand' },
]

export default function PriceDiscountGroupedByToggleButton() {

    return <ToggleButtonSeeker
        value={groupedBy.value}
        tabs={GROUPED_TABS}
        onChange={(_, newValue) => batch(() => {
            groupedBy.value = newValue
            isLoadingByGroupToggle.value = true
        })}
    />
}